export default (process.env.NODE_ENV === 'production') ?
    require('./config.prod.json') :
    require('./config.dev.json');


// WEBPACK FOOTER //
// ./src/js/serverApi/config.js